import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import './RoomListItem.css';
import ListEditButtons from '../ListEditButtons/ListEditButtons';

function RoomListItem(props) {

    let isHotelDetails = (props.hotelId === undefined && props.hotelName === undefined) ? true : false;

    return (

        <Fragment>

            <div className="col-lg-4 col-md-6 col-sm-12">


                <div className="card card-spacer">


                        <Link to={'/rooms/' + props.id}>
                            <img className=" card-img-top"
                                 src={(props.imageUrl && props.imageUrl.trim() !== "") ? props.imageUrl : "/images/noimage.png"}
                                 alt="Room"/>
                        </Link>

                    <div className="card-body room">

                        {isHotelDetails ? "" : <Link to={'/hotels/' + props.hotelId} >
                            <h3 className="card-title hotelname">{props.hotelName}</h3>
                        </Link> }
                        <hr/>
                        <Link to={'/rooms/' + props.id}><h4 className="card-title">{props.name}</h4></Link>
                        <p><strong>Number of beds: </strong> {props.numberOfBeds}</p>
                        <h3 className="card-description"> {props.pricePerNight}$ /night </h3>

                            {isHotelDetails ?
                            <Link to={'/rooms/' + props.id} className="btn btn-primary">
                                Go to reservation
                            </Link> :
                            <Link to={'/hotels/' + props.hotelId} className="btn btn-primary">
                            Go to the hotel
                        </Link> }
                        <div>
                            {isHotelDetails ? "" :
                                <ListEditButtons
                                    to={"/modify-room/" + props.id}
                                    deleteHandler={props.deleteHandler}
                                />
                            }
                        </div>
                    </div>
                </div>

            </div>


            <br/>
        </Fragment>


    )
}

export default RoomListItem;


// WEBPACK FOOTER //
// ./src/components/RoomListItem/RoomListItem.jsx